export default __webpack_public_path__ + "static/printer_w.58fc48865031482c5950c59c29dbecd7.svg";